<nz-drawer
  [nzVisible]="visible"
  [nzWidth]="560"
  nzPlacement="right"
  [nzClosable]="false"
  [nzMaskClosable]="!submitting"
  [nzTitle]="drawerTitleTpl"
  (nzOnClose)="close()"
  [testId]="'tenant-point-grant-drawer'"
>
  <ng-container *nzDrawerContent>
    <div class="drawer-body" [testId]="'tenant-point-grant-drawer-body'">
      <ng-container *ngIf="!resultState; else resultBlock">
        <nz-spin [nzSpinning]="loadingBalance" [testId]="'tenant-point-grant-balance-spin'">
          <section class="panel-card tenant-summary" [testId]="'tenant-point-grant-summary'">
            <div class="summary-grid">
              <div class="summary-block">
                <div class="summary-block__label">{{ 'tenant.point-grant.target-tenant' | i18n }}</div>
                <div class="summary-block__value">{{ displayTenantName }}</div>
                <div class="summary-block__meta">{{ 'tenant.point-grant.account-id' | i18n }}</div>
                <div class="summary-block__subvalue">{{ displayOpenId }}</div>
              </div>
              <div class="summary-block summary-block--balance">
                <div class="summary-block__label">{{ 'tenant.point-grant.current-balance' | i18n }}</div>
                <div class="summary-block__balance">{{ formatBalance(currentBalance) }} {{ 'tenant.point-grant.points-unit' | i18n }}</div>
              </div>
            </div>
          </section>
        </nz-spin>

        <form nz-form nzLayout="vertical" [formGroup]="reasonForm" class="grant-form" [testId]="'tenant-point-grant-form'">
          <section class="panel-card" [testId]="'tenant-point-grant-form-card'">
            <nz-form-item class="grant-form__item">
              <nz-form-label nzRequired [nzNoColon]="true">{{ 'tenant.point-grant.amount' | i18n }}</nz-form-label>
              <nz-form-control [nzErrorTip]="'tenant.point-grant.validation.amount' | i18n">
                <div class="amount-field" [testId]="'tenant-point-grant-amount-field'">
                  <input
                    nz-input
                    class="grant-control grant-control--amount-input"
                    type="text"
                    inputmode="numeric"
                    autocomplete="off"
                    formControlName="amount"
                    [placeholder]="'tenant.point-grant.amount-placeholder' | i18n"
                    (input)="onAmountInput($event)"
                    [testId]="'tenant-point-grant-amount-input'"
                  />
                </div>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item class="grant-form__item">
              <nz-form-label nzRequired [nzNoColon]="true">{{ 'tenant.point-grant.reason' | i18n }}</nz-form-label>
              <nz-form-control [nzErrorTip]="'tenant.point-grant.validation.reason' | i18n">
                <nz-select
                  class="grant-control"
                  formControlName="reason"
                  [nzPlaceHolder]="'tenant.point-grant.reason-placeholder' | i18n"
                  [testId]="'tenant-point-grant-reason-select'"
                >
                  <nz-option *ngFor="let option of reasonOptions" [nzValue]="option.value" [nzLabel]="option.labelKey | i18n" />
                </nz-select>
              </nz-form-control>
            </nz-form-item>

            <nz-form-item class="grant-form__item">
              <nz-form-label [nzRequired]="isRemarkRequired()" [nzNoColon]="true">{{ 'tenant.point-grant.remark' | i18n }}</nz-form-label>
              <nz-form-control [nzErrorTip]="isRemarkRequired() ? ('tenant.point-grant.validation.remark' | i18n) : undefined">
                <textarea
                  nz-input
                  class="grant-control grant-control--textarea"
                  rows="4"
                  formControlName="remark"
                  [placeholder]="'tenant.point-grant.remark-placeholder' | i18n"
                  [testId]="'tenant-point-grant-remark-input'"
                ></textarea>
              </nz-form-control>
            </nz-form-item>
          </section>
        </form>

        <div class="confirm-banner" *ngIf="confirmingSubmit" [testId]="'tenant-point-grant-confirm-banner'">
          <div class="confirm-banner__icon">
            <i nz-icon nzType="exclamation-circle" nzTheme="fill"></i>
          </div>
          <div class="confirm-banner__content">
            <div class="confirm-banner__title">{{ confirmTitle }}</div>
            <div class="confirm-banner__desc">{{ confirmSummary }}</div>
            <div class="confirm-banner__hints" *ngIf="confirmHints.length">
              <div class="confirm-banner__hint" *ngFor="let hint of confirmHints">{{ hint }}</div>
            </div>
            <div class="confirm-banner__trace" *ngIf="confirmTraceId">
              {{ 'tenant.point-grant.trace-id' | i18n }}: {{ confirmTraceId }}
            </div>
          </div>
        </div>

        <div class="action-row" [testId]="'tenant-point-grant-action-row'">
          <button
            nz-button
            nzType="default"
            (click)="confirmingSubmit ? cancelConfirm() : close()"
            [disabled]="submitting"
            [testId]="'tenant-point-grant-close-button'"
          >
            {{ (confirmingSubmit ? 'common.cancel' : 'common.close') | i18n }}
          </button>
          <button
            nz-button
            nzType="primary"
            (click)="onPrimaryAction()"
            [nzLoading]="submitting"
            [disabled]="!resultState && !canSubmit()"
            [testId]="'tenant-point-grant-submit-button'"
          >
            {{ primaryButtonText }}
          </button>
        </div>
      </ng-container>

      <ng-template #resultBlock>
        <div
          class="result-panel"
          [class.is-success]="resultState === 'success'"
          [class.is-processing]="resultState === 'processing'"
          [class.is-error]="resultState === 'error'"
          [testId]="'tenant-point-grant-result-panel'"
        >
          <div class="result-panel__icon">
            <i
              nz-icon
              [nzType]="resultState === 'success' ? 'check-circle' : resultState === 'processing' ? 'clock-circle' : 'close-circle'"
              [nzTheme]="'fill'"
            ></i>
          </div>
          <div class="result-panel__title" [testId]="'tenant-point-grant-result-title'">{{ resultTitle }}</div>
          <div class="result-panel__desc" [testId]="'tenant-point-grant-result-desc'">{{ resultMessage }}</div>
          <div class="result-panel__trace" *ngIf="resultTraceId"> {{ 'tenant.point-grant.trace-id' | i18n }}: {{ resultTraceId }} </div>
        </div>
      </ng-template>
    </div>
  </ng-container>
</nz-drawer>

<ng-template #drawerTitleTpl>
  <div class="drawer-title-shell" [testId]="'tenant-point-grant-title-shell'">
    <div class="drawer-title-copy" [testId]="'tenant-point-grant-title-copy'">
      <div class="drawer-title-shell__title" [testId]="'tenant-point-grant-title'">{{ drawerTitle }}</div>
      <div class="drawer-title-shell__subtitle" [testId]="'tenant-point-grant-subtitle'">{{ drawerSubtitle }}</div>
    </div>
    <button
      type="button"
      class="drawer-close-button"
      (click)="close()"
      [attr.aria-label]="'common.close' | i18n"
      [testId]="'tenant-point-grant-title-close-button'"
    >
      <i nz-icon nzType="close"></i>
    </button>
  </div>
</ng-template>
